import { ViewStyle, useWindowDimensions } from 'react-native';

/**
 * Max width for content areas on web/tablet.
 * On mobile (<= this value), content is full-width.
 * On wider screens, content is centered at this max width.
 */
export const WEB_MAX_WIDTH = 640;

/**
 * Style to apply to ScrollView contentContainerStyle or inner wrappers
 * to constrain content width on wide screens.
 */
export const responsiveContentStyle: ViewStyle = {
  maxWidth: WEB_MAX_WIDTH,
  width: '100%',
  alignSelf: 'center',
};

/**
 * Hook providing responsive layout info.
 */
export function useResponsiveLayout() {
  const { width } = useWindowDimensions();
  return {
    isWide: width > WEB_MAX_WIDTH,
    screenWidth: width,
    maxWidth: WEB_MAX_WIDTH,
  };
}
